import imageUrlBuilder from '@sanity/image-url'

const builder = imageUrlBuilder({
  projectId: '22xmfoma',
  dataset: process.env.GATSBY_SANITY_DATASET || 'production'
})

export function imageUrlFor (source) {
  return builder.image(source)
}
